module.exports = require('./helpers/bundle-url').getBundleURL('e1ick') + "logo.c51670a8.svg";